<template>
    <input readonly :value="initialValue"/>
</template>
<script>
    export default {
        name : 'invision-read-only',
        props: ['initial-value'],
    }
</script>